import React from 'react';
import { HBox, VBox } from '../../../../components/Box';
import { Button } from '../../../../components/Buttons';
import { lbl } from '../../../../utils/intl';
import styled from 'styled-components';
import { COLOR_BG_LIGHT } from '../../../../vars';
import { SearchSelect } from '../../../../components/SearchSelectComponent';

import styles from './websiteUsersMainFilterSection.module.css';

import { CircleTimes } from '../../../../components/Icon';

const Container = styled.div`
  float: left;
  width: 100%;

  & * .Dropdown-root {
    width: 100%;
  }

  .basic-multi-select {
    width: 100%;
  }
  .filters-rows {
    gap: 12px;
    padding: 0px 24px 24px 24px;
    background-color: white;
    // margin-bottom: 22px;
    @media (max-width: 768px) {
      max-width: 100%;
      padding: 15px;
    }
  }

  .form-control {
    margin-bottom: 0;
  }

  .button {
    width: auto;
  }

  .all-filters-block {
    padding: 10px;
    background-color: ${COLOR_BG_LIGHT};
  }

  .button-filter {
    padding-left: ${props => props.width > 500 && '24px'};
    & * .button {
      margin: 0px;
      margin-left: 12px;
      background-color: white;
      color: #808c9c;
      border-radius: 8px 8px 0px 0px;
      box-shadow: 0 -2px 6px -1px #ececef;
      &:hover {
        background-color: #0183d5;
        color: #fff;
        box-shadow: none;
      }
    }
  }

  .row-1 {
    & * .decorated {
      width: 100%;
    }
  }

  .grid-column {
  }

  .grid-row-long {
    flex-basis: ${props => (props.width <= 1520 ? '100%' : '49%')};
  }
  .grid-row-short {
    border: 1px solid #cccccc;
    border-radius: 3px;
    flex-basis: 49%;
    & > .button {
      margin: 0px;
    }
  }

  .tablet-row {
    margin-bottom: 22px;
  }

  .row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .button-block {
    & * .button {
      margin: 0px;
    }
  }
  .input-element {
    font-size: 13px;
    height: 45px;
  }
`;

const Container2 = styled.div`
  .ranged {
    min-width: ${props => (props.controlWidth ? props.controlWidth : '55%')};
  }

  min-width: ${props => (props.minWidth ? props.minWidth : '')};

  .button-filter-block {
    // position: absolute;
    top: -50px;
    left: 0px;
  }
  .selected {
    background-color: #0183d5 !important;
    color: white !important;
  }import { WebsiteUsersMainFilterSection } from './websiteUsersMainFilterSection';

`;

export const WebsiteUsersMainFilterSection = props => {
  const isAllSelected = () => {
    if (props.usersOverviewPage) {
      return props.selected == 'all';
    }

    return !props.selected;
  };

  const renderButtonLabel = filterName => {
    return (
      <VBox vCenter center>
        {props.usersOverviewPage && lbl('leftBar.website_users')}
        {lbl(`website.users.filter.${filterName}`)}
      </VBox>
    );
  };

  const renderDropdownFilters = () => {
    const options = [
      { label: lbl(`website.users.filter.${'all'}`), value: 'all' },
      { label: lbl(`website.users.filter.${'pending_registrations'}`), value: 'evaluate_for_website' },
      { label: lbl(`website.users.filter.${'pending_verifications'}`), value: 'user_website_data_evaluate' },
    ];
    const selected = options?.find(opt => opt?.value == props.selected);

    return (
      <Container>
        <HBox>
          <SearchSelect
            placeholder={'Website users'}
            value={selected?.value ? selected : null}
            options={options}
            onChange={opt => {
              props.onSelect(opt.value);
            }}
          />

          {/* <button
            className={`btn btn-outline-secondary ${styles.Button}`}
            type="button"
            onClick={() => {
              props.onSelect(null);
            }}
          >
            <CircleTimes />
          </button> */}
        </HBox>
      </Container>
    );
  };
  if (props.renderDropdownFilters) return renderDropdownFilters();
  return (
    <Container width={window.innerWidth}>
      <HBox left className="button-filter">
        <Container2 minWidth={props.minWidth} controlWidth={props.controlWidth}>
          <HBox vCenter left className="button-filter-block">
            <Button
              small
              select={isAllSelected}
              onClick={() => {
                if (props.usersOverviewPage) {
                  return props.onSelect('all');
                }
                props.onSelect(null);
              }}
              className={isAllSelected() ? 'selected' : ''}
            >
              {renderButtonLabel('all')}
            </Button>
            <Button
              small
              select={props.selected === 'evaluate_for_website'}
              onClick={() => {
                props.onSelect('evaluate_for_website');
              }}
              className={props.selected === 'evaluate_for_website' ? 'selected' : ''}
            >
              {renderButtonLabel('pending_registrations')}
            </Button>
            <Button
              small
              select={props.selected === 'evaluate_for_website'}
              onClick={() => {
                props.onSelect('user_website_data_evaluate');
              }}
              className={props.selected === 'user_website_data_evaluate' ? 'selected' : ''}
            >
              {renderButtonLabel('pending_verifications')}
            </Button>
          </HBox>
        </Container2>
      </HBox>
    </Container>
  );
};
